import { useEffect, useState } from 'react';
import clsx from 'clsx';
import __isEmpty from 'lodash/isEmpty';
import Image from 'next/image';
import styles from './avisUHDHDR.module.scss';

export default function AvisUHDHDR(props) {
    const { estil } = props;
    const [supportsUHD, setSupportsUHD] = useState(true);
    const [supportsHDR, setSupportsHDR] = useState(true);

    useEffect(() => {
        const checkCapabilities = async () => {
            try {
                // --- Comprobació UHD (4K) ---
                // UHD normalment implica resolució >= 3840x2160
                const { width, height } = window.screen;
                const isUHD = width >= 3840 && height >= 2160;
                setSupportsUHD(isUHD);

                // --- Comprovació HDR ---

                // Usem MediaCapabilities API si està disponible
                // let isHDR = false;
                // if ('mediaCapabilities' in navigator) {
                //     const hdrConfig = {
                //         type: 'file',
                //         video: {
                //             contentType: 'video/webm;codecs=vp9',
                //             width: 3840,
                //             height: 2160,
                //             bitrate: 10000000,
                //             framerate: 30,
                //             colorSpace: 'bt2020', // espai de color HDR
                //             transferFunction: 'pq' // Perceptual Quantizer
                //         }
                //     };

                //     const result = await navigator.mediaCapabilities.decodingInfo(hdrConfig);
                //     isHDR = result.supported && result.colorGamut === 'bt2020';
                // } else {
                //     // Si no hi ha API, assumim que no suporta HDR
                //     isHDR = false;
                // }

                // const isHDR = window.matchMedia && window.matchMedia('(dynamic-range: high)').matches;

                const hasMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia === 'function';

                const mqDynamic = hasMatchMedia ? window.matchMedia('(dynamic-range: high)') : null;
                const mqRec2020 = hasMatchMedia ? window.matchMedia('(color-gamut: rec2020)') : null;

                const isHDR = Boolean((mqDynamic && mqDynamic.matches) || (mqRec2020 && mqRec2020.matches));

                setSupportsHDR(isHDR);
                console.log('Supports UHD:', isUHD, 'Supports HDR:', isHDR);
            } catch (err) {
                console.error('Error comprovant capacitats:', err);
                setSupportsUHD(false);
                setSupportsHDR(false);
            }
        };

        checkCapabilities();
    }, []);

    if (!supportsUHD || !supportsHDR) {
        return (
            <div className={clsx(styles.avisUHDHDR, estil === 'webview' && styles.webview)}>
                La disponibilitat d’UHD depèn del teu dispositiu
            </div>
        );
    }
}
